module.exports = __webpack_public_path__ + "img/about_dataflow.a75331ac.svg";